import { useEffect } from 'react';
import { STORAGE_KEYS } from '../config';
import usePushNotification from '../hooks/usePushNotification';
import useAuth from '../hooks/useAuth';

function HomePage() {
  const fcmToken = usePushNotification();
  const { loading } = useAuth();

  useEffect(() => {
    if (!loading && fcmToken) {
      window.localStorage.setItem(STORAGE_KEYS.FCM_TOKEN, fcmToken);
    }
  }, [fcmToken, loading]);

  return (
    <div className='flex justify-center h-screen'>
      <h1 className='flex items-center text-2xl text-center text-blue-600'>
        CheckN <br />
        Walkin Service
      </h1>
    </div>
  );
}

export default HomePage;
